export interface CoBrowsingFilterParams {
  coBrowsingUserEmail: string | null;
  userAccessType: string | null | undefined;
  coBrowsingCompanyId: string | null | undefined;
  isRestrictedRole: (accessType?: string | null) => boolean;
}

export interface ItemWithCompanyId {
  companyId: number | string;
}

export function shouldIncludeItemForCoBrowsing<T extends ItemWithCompanyId>(
  item: T,
  params: CoBrowsingFilterParams,
): boolean {
  const isCoBrowsingSession = !!params.coBrowsingUserEmail;
  const isRestrictedRole = params.isRestrictedRole(params.userAccessType);

  if (!isCoBrowsingSession || !isRestrictedRole) {
    return true;
  }

  if (!params.coBrowsingCompanyId) {
    return true;
  }

  return item.companyId.toString() === params.coBrowsingCompanyId.toString();
}

export function createCoBrowsingFilter<T extends ItemWithCompanyId>(
  params: CoBrowsingFilterParams,
): (item: T) => boolean {
  return (item: T) => shouldIncludeItemForCoBrowsing(item, params);
}
